import { createContext } from "react";

import { IWithSearchContextProps } from "./IWithSearchContextProps";

export const SearchContext = createContext<IWithSearchContextProps>({
  focusBackToSearchbox: null,
  focusZoneRef: null,
  isCallOutVisible: false,
  isCalloutFocused: false,
  onAdd: null,
  onChange: null,
  onDismiss: null,
  onEdit: null,
  onRemove: null,
  searchHighlight: null,
  searchRef: null,
  searchTerm: null,
  setFocusBackToSearchbox: null,
  setIsCallOutVisible: null,
  setIsCalloutFocused: null,
  setSearchHighlight: null,
  setSearchTerm: null,
  tokenSetList: null
});
